import { gql } from "@apollo/client";

export const QUERY_FORM3454F_VERSION = gql`
  query studentForm3454F(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3454F(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      reportOfPerformanceChart
      reportOfPerformanceChart2
      formAction
      formStatus
    }
  }
`;
